exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control--AwZ80 {\n  max-width: 260px;\n  display: inline-block;\n  padding: 0 5px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.modal--2SWsE {\n  max-width: 600px;\n}\n\n.modal-content--1wsv4 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n\n.modal-content--1wsv4 > form {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  height: 100%;\n}\n\n.inputs--3hXmz {\n  max-width: 380px;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n\n.summary--31FsS {\n  text-align: center;\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.submit--3J13s {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.submit--3J13s .button--3hpF4 {\n  margin: 10px;\n}\n", ""]);

// exports
exports.locals = {
	"control": "control--AwZ80",
	"modal": "modal--2SWsE",
	"modal-content": "modal-content--1wsv4",
	"inputs": "inputs--3hXmz",
	"summary": "summary--31FsS",
	"submit": "submit--3J13s",
	"button": "button--3hpF4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/list-items/ProcessingUser/ProcessingUserAccesses/RemoveProcessingUserAccess/RemoveProcessingUserAccess.m.scss
// module id = 1574
// module chunks = 0